import classNames from "classnames";
import React, { createRef } from "react";
import { Button, Input, InputGroup } from "reactstrap";
import FinalTableSpy from "../FinalTable/FinalTableSpy";
import "./SearchField.scss";

interface SearchFieldProps {
  disabled?: boolean;
  style?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
  placeholder?: string;
  onSubmit?: () => void;
}

export default class SearchField extends React.Component<SearchFieldProps> {
  inputRef = createRef<Input>();

  render() {
    const { disabled, style, placeholder, inputStyle, onSubmit } = this.props;
    return (
      <FinalTableSpy>
        {props => (
          <div className={classNames("table-search-v2", { disabled })} style={style}>
            <form
              onSubmit={event => {
                event.preventDefault();
                const searchText = event.target[0].value;
                props.update({ page: 1, query: { searchText } });
              }}>
              <InputGroup className="input-group">
                <Input
                  ref={this.inputRef}
                  type="search"
                  disabled={disabled}
                  placeholder={placeholder}
                  style={inputStyle}
                  onInput={event => {
                    const searchText = event.currentTarget.value;
                    const inputType = (event.nativeEvent as any).inputType;
                    if (!inputType && searchText === "") {
                      props.update({ page: 1, query: { searchText } });
                    }
                  }}
                />
                <Button color="secondary" className="search-btn" type="submit" onClick={onSubmit} />
              </InputGroup>
            </form>
          </div>
        )}
      </FinalTableSpy>
    );
  }
}
